/**
 * @fileoverview Agent definition for the c-storyline-extractor-v1 primitive.
 *
 * Extracts C-Stories (tangential subplots for breadth and relief) using
 * the A-Story timeline as a reference anchor. Part of the split
 * extraction pipeline.
 *
 * @category import.story.extraction
 * @type primitive
 * @see docs/story-architecture.md
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'c-storyline-extractor-v1',
  kind: 'primitive',
  name: 'C-Story Extractor',
  description: 'Extracts C-Stories (tangential subplots for breadth and relief) with the A-Story as reference anchor.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'import.story.extraction',
    usedBy: [],
    relatedAgents: ['a-storyline-extractor-v1', 'b-storyline-extractor-v1', 'storyline-extraction-pipeline-v1'],
  },
};
